import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { Benefits } from './components/Benefits';
import { TriGripSystem } from './components/TriGripSystem';
import { WhoIsItFor } from './components/WhoIsItFor';
import { SocialProof } from './components/SocialProof';
import { Solution } from './components/Solution';
import { ProductStack } from './components/ProductStack';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-dark-900 text-white selection:bg-neon-cyan selection:text-dark-900" data-id="element-0">
      <Hero data-id="element-1" />
      <PainSection data-id="element-2" />
      <Solution data-id="element-3" />
      <Benefits data-id="element-4" />
      <TriGripSystem data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <SocialProof data-id="element-7" />
      <ProductStack data-id="element-8" />
      <Offer data-id="element-9" />
      <FAQ data-id="element-10" />

      {/* Footer */}
      <footer className="py-8 bg-dark-900 border-t border-dark-800 text-center text-gray-500 font-inter text-sm pb-24 md:pb-8" data-id="element-11">
        <p data-id="element-12">
          © {new Date().getFullYear()} Grip Dominante. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs" data-id="element-13">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </footer>

      <StickyCTA data-id="element-14" />
    </div>;
}